//#region import
import React, { useContext, useEffect, useRef, useState } from 'react';
import { ProjectContext } from '../ProjectRequestFrom';
import { Convert, Extension, FnAxios, FnDialog, I18n } from 'utilities/utilities';
import { useLocation, useNavigate } from 'react-router';
import { FormProvider, useForm } from 'react-hook-form';
import { ApiProject } from 'enum/api';
import { APIStatusCode, EnumProjectStatusID, I18NextNs } from 'enum/enum';
import { Grid } from '@mui/material';
import { SelectItem } from 'components/Input/Select/SelectItem';
import UploadFileItem from 'components/Input/UploadFile';
import { TextAreaItem } from 'components/Input/TextArea';
import { BtnCancel, BtnConfirm, BtnSendRequest } from 'components/Button/ButtonAll';
import ContentWrapper from '../components/ContentWrapper';
//#endregion

const ProjectChangeStatus = () => { //ขยายระยะเวลา โครงการ
    const {
        nProjectID,
        setnProjectID,
        isFastTrack,
        isPermission,
        ObjProjectRequest,
        arrisEditPanel,
        setarrisEditPanel,
        nStatusID,
        isSubmit,
        setisSubmit,
        ObjStepFlowProject,
        isModeSecretary,
        nProjectVersionID,
        sTabID,
        nLogChangeID,
        setnLogChangeID,
        ObjCheckSubmitVersion,
        setObjCheckSubmitVersion,
    } = useContext(ProjectContext);

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();
    const navigate = useNavigate();

    const [isEditSecretary, setisEditSecretary] = useState(isPermission);
    const [ObjProjectChangeStatus, setObjProjectChangeStatus] = useState(null);
    const [arrDataProjectChangeStatusID, setarrDataProjectChangeStatusID] = useState([]);

    const [isRequired, setisRequired] = useState(false);    
    const [sStatusName, setsStatusName] = useState(null);

    const onClearFile = useRef(null);
    const [lstFileChangeStatus, setlstFileChangeStatus] = useState([]);

    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            nStatusID_ChangeStatus: null,
            sRemark_ChangeStatus: null,
        } as any,
    });

    useEffect(() => {
        if (nLogChangeID !== null && isPermission === true) setisEditSecretary(false);
    }, [nLogChangeID, isPermission]);

    useEffect(() => {
        if (ObjProjectChangeStatus !== null) 
        {
            // setisEditSecretary(ObjProjectChangeStatus?.nProject_nLogChangeID === null ? isPermission : false);
            form.setValue("nStatusID_ChangeStatus", ObjProjectChangeStatus?.nToStatusID);
            form.setValue("sRemark_ChangeStatus", ObjProjectChangeStatus?.sRemark);
            setlstFileChangeStatus(ObjProjectChangeStatus?.lstFileChangeStatus ?? []);
        }
    }, [ObjProjectChangeStatus]);

    useEffect(() => {
        if (nProjectID !== 0) handleGetFormProjectID();
    }, [nProjectID]);

    const handleGetFormProjectID = () => {
        AxiosFn.Get(ApiProject.GetFormProjectChangeStatus, { nProjectID : nProjectID }, (result) => {
            setarrDataProjectChangeStatusID(result.lstProjectChangeStatusID);        
            setObjProjectChangeStatus(result.ObjDataProjectChangeStatus);
        });
    };

    const handleSubmit = () => {
        if (lstFileChangeStatus.filter(f => !f.isDelete).length === 0) {
            return DialogFn.Warning("กรุณาอัพโหลดไฟล์แนบเอกสารหลักฐาน");
        } 
        let ObjForm = form.getValues();
        let param = {
            sLocation: location.pathname,

            nProjectID: nProjectID,
            nProject_nLogChangeID: ObjProjectChangeStatus?.nProject_nLogChangeID ?? null, //สถานะการปรับแผนโครงการ TbLogProjectChangeStatus ค่าจะปรับเป็น NULL เมื่อมีการกดปุ่มยืนยันการปรับแผน           
            nLogChangeID: ObjProjectChangeStatus?.nLogChangeID ?? 0,
            nToStatusID: Convert.StringToInt(ObjForm.nStatusID_ChangeStatus),
            sRemark: ObjForm.sRemark_ChangeStatus,
            lstFileChangeStatus: lstFileChangeStatus ?? [], //ไฟล์ทั้งหมด

            // nFromStatusID: ObjProjectChangeStatus.nFromStatusID,
            // dStartBefore: ObjProjectChangeStatus.dStartBefore,
            // nDateStartBefore: ObjProjectChangeStatus.nDateStartBefore,
            // dEndBefore: ObjProjectChangeStatus.dEndBefore,
            // nDateEndBefore: ObjProjectChangeStatus.nDateEndBefore,
            // dStartAfter: ObjProjectChangeStatus.dStartAfter,
            // nDateStartAfter: ObjProjectChangeStatus.nDateStartAfter,
            // dEndAfter: ObjProjectChangeStatus.dEndAfter,
            // nDateEndAfter: ObjProjectChangeStatus.nDateEndAfter,
        };
        DialogFn.Submit("คุณต้องการบันทึก" + sStatusName + "หรือไม่ ?", () => {
            DialogFn.BlockUI();
            AxiosFn.Post(ApiProject.SaveProjectChangeStatus, param, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === APIStatusCode.Success)
                {
                    DialogFn.Success("บันทึก" + sStatusName + "สำเร็จ", () => {
                        setisEditSecretary(false);
                        setnLogChangeID(result.objResult?.nLogChangeID);

                        //29 ขยายระยะเวลาโครงการ | 30 ยกเลิกโครงการ | 36 ปรับแผนโครงการ
                        if(Convert.StringToInt(ObjForm.nStatusID_ChangeStatus) === EnumProjectStatusID.nStatusID_30) navigate("/ProjectCheckRecordList");
                    });
                } else {
                    DialogFn.Warning(result.sMessage);                    
                }
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };
    
    const onClearField = () => {
        Object.keys(form.getValues()).forEach((key) => {
            form.setValue(key, null);
            form.clearErrors(key);
        });
        setlstFileChangeStatus([]);
        onClearFile.current();
    };
    
    const handleSubmitVersion = () => {
        let param = {
            sLocation: location.pathname,
            nProjectID: nProjectID,
            nLogChangeID: ObjProjectChangeStatus?.nProject_nLogChangeID, //สถานะการปรับแผนโครงการ TbLogProjectChangeStatus ค่าจะปรับเป็น NULL เมื่อมีการกดปุ่มยืนยันการปรับแผน
            isNotChange: false,
        };
        DialogFn.Submit("คุณต้องการบันทึกข้อมูลเป็นเวอร์ชั่นหรือไม่ ?", () => {
            DialogFn.BlockUI();
            AxiosFn.Post(ApiProject.SaveProjectVersion, param, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === APIStatusCode.Success)
                {
                    DialogFn.Success("บันทึกข้อมูลเป็นเวอร์ชั่นสำเร็จ", () => { setnLogChangeID(null); onClearField(); navigate("/ProjectCheckRecordList"); });
                } else {
                    DialogFn.Warning(result.sMessage);
                }
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    useEffect(() => {
        if (ObjCheckSubmitVersion?.isPanel9 === true){
            if (ObjCheckSubmitVersion?.isWorkPlan === false) document.getElementById("btnCheck_WorkPlan_ChangeStatus").click();
            if (ObjCheckSubmitVersion?.isSpendingPlan === false) document.getElementById("btnCheck_SpendingPlan_ChangeStatus").click();
        }

        if (ObjCheckSubmitVersion?.isPanel9 === true && ObjCheckSubmitVersion?.isWorkPlan === true && ObjCheckSubmitVersion?.isSpendingPlan === true) 
        {
            if (ObjCheckSubmitVersion?.sWarningPanel9 !== null || ObjCheckSubmitVersion?.sWarningWorkPlan !== null || ObjCheckSubmitVersion?.sWarningSpendingPlan !== null)
            {
                DialogFn.Warning((ObjCheckSubmitVersion?.sWarningPanel9 ?? "") + (ObjCheckSubmitVersion?.sWarningWorkPlan ?? "") + (ObjCheckSubmitVersion?.sWarningSpendingPlan ?? ""));
            }
            else
            {
                handleSubmitVersion();           
            }
            setObjCheckSubmitVersion({
                isPanel9: false,
                sWarningPanel9: null,
                isWorkPlan: false,
                sWarningWorkPlan: null,
                isSpendingPlan: false,
                sWarningSpendingPlan: null,
            }); //Error ของ (Panel 9 || WorkPlan 2/1 || SpendingPlan 2/2)
        }
    }, [ObjCheckSubmitVersion]);

    return (
        <ContentWrapper style={{ border: '0px solid #f1f1f1 !important', marginTop: '3%', borderRadius: '10px', paddingBottom: '1%', padding: '2%', backgroundColor: '#fffbee6e',}}>
            <FormProvider {...form}>
                <Grid item xs={12} md={12} container spacing={2}>
                    <Grid item xs={12} md={3}>
                        <SelectItem
                            id="nStatusID_ChangeStatus"
                            name="nStatusID_ChangeStatus"
                            options={arrDataProjectChangeStatusID}
                            label={"สถานะโครงการ"}
                            required={true}
                            disabled={isEditSecretary === false ? true : false}
                            onChange={(e)=> {
                                setsStatusName(e !== null ? e.label : null);
                                //29 ขยายระยะเวลาโครงการ | 30 ยกเลิกโครงการ | 36 ปรับแผนโครงการ
                                // if (e !== null) { 
                                //     setisRequired(e?.value === 30 ? true : false);
                                // }
                            }}  
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <TextAreaItem
                            id={"sRemark_ChangeStatus"}
                            name={"sRemark_ChangeStatus"}
                            label={"หมายเหตุ/เหตุผล"}                               
                            required={true} //{isRequired}
                            maxLength={500}
                            row={3}
                            disabled={isEditSecretary === false ? true : false}
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <UploadFileItem
                            required={true} //{isRequired}
                            modeDisplay={"list"}
                            id={"oFileChangeStatus"}
                            name={"oFileChangeStatus"}
                            label={"แนบเอกสารหลักฐาน"}
                            arrFile={lstFileChangeStatus}
                            setarrFile={setlstFileChangeStatus}
                            // Extension={Extension.Image_New}
                            Extension={["pdf", "jpg", "jpeg", "png"]}
                            IsFolder={false}
                            onClearFile={onClearFile}
                            sFolderTemp="Project"
                            IsMultiple={true}
                            nLimitFile={10}
                            sLimitFile="MB"
                            sPositionText="right"
                            IsCrop={true}
                            cropShape={"retangle"}
                            cropRatio={16 / 9}
                            cropResize={true}
                            cropMovable={true}
                            disabled={isEditSecretary === false ? true : false}
                        />
                    </Grid>                   
                </Grid>
                {isEditSecretary === true &&
                    <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '1%', }} justifyContent="end">
                        {/* <Grid item>
                            <BtnCancel id={"btnCancel_ChangeStatus"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={() => { onClearField(); }} />
                        </Grid> */}
                        <Grid item>
                            <BtnConfirm id={"btnConfirm_ChangeStatus"} txt={I18n.SetText("Button.Confirm", I18NextNs.labelComponent)} onClick={form.handleSubmit((e) => handleSubmit(),(err) => console.log("err", err))} />
                        </Grid>
                    </Grid>
                }
                {/* <Grid item style={{ display: 'none'}}>
                    <BtnConfirm id="BtnConfirmVersion"
                        onClick={(e) => {
                            document.getElementById("btnCheck_Panel9_ChangeStatus").click();
                            document.getElementById("btnCheck_WorkPlan_ChangeStatus").click();
                            document.getElementById("btnCheck_SpendingPlan_ChangeStatus").click();
                        }}
                    />
                </Grid> */}
            </FormProvider>
        </ContentWrapper>
    )
}
export default ProjectChangeStatus;
